import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../../lib/useSettings";
import { Megaphone, ArrowRight } from "lucide-react";

export default function PromoBanner() {
  const { settings: s } = useSettings();
  const c = s?.home_sections_content?.promo_banner || {};
  const text = c.text || "";
  if (!text) return null;
  const bg = c.bg || "#0B2242";
  const fg = c.fg || "#FFFFFF";
  const linkLabel = c.link_label || "";
  const linkUrl = c.link_url || "";

  return (
    <div
      className="w-full text-center text-xs md:text-sm font-semibold py-2.5 px-4"
      style={{ background: bg, color: fg }}
      data-testid="promo-banner"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <Megaphone className="w-3.5 h-3.5 opacity-80" />
        <span>{text}</span>
        {linkLabel && linkUrl && (
          <Link to={linkUrl} className="inline-flex items-center gap-1 underline underline-offset-2 font-bold hover:opacity-80">
            {linkLabel} <ArrowRight className="w-3 h-3" />
          </Link>
        )}
      </div>
    </div>
  );
}
